import script from "./LeaderboardMotion.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderboardMotion.vue?vue&type=script&setup=true&lang=js"

import "./LeaderboardMotion.vue?vue&type=style&index=0&id=4038c649&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src1350238635/src/wfyt-leaderboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4038c649"]])

export default __exports__